const resolveCurrentProperty = (customProps, properties, name) => {
  let finalClass = '';
  if (!Array.isArray(properties)) return finalClass;

  const propKeys = Object.keys(customProps);

  // Check user props inside Component Schema
  for (let i = 0, lgt = propKeys.length; i < lgt; i += 1) {
    const currentPropName = propKeys[i];
    if (customProps[currentPropName] === true) {
      if (properties.find((prop) => (prop === currentPropName || prop.title === currentPropName))) {
        finalClass += `mdn-${name}--${currentPropName} `;
      }
    }
  }

  // If user props does not match Component Schema, find default value:
  if (!finalClass) {
    const defaultValue = properties.find((prop) => prop.isDefault === true);
    if (defaultValue) finalClass += `mdn-${name}--${defaultValue.title} `;
  }

  return finalClass;
};

const resolveProps = (props, config, name) => {
  let finalClassName = `mdn-${name} `;

  finalClassName += resolveCurrentProperty(props, config.types, name);
  finalClassName += resolveCurrentProperty(props, config.modifiers, name);
  finalClassName += resolveCurrentProperty(props, config.states, name);

  finalClassName += props.className || '';

  return finalClassName;
};

export {
  resolveCurrentProperty,
};

export default resolveProps;
